import api from './api';

export const adminAuth = {
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    const { admin, token } = response.data;
    
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(admin));
    localStorage.setItem('userType', 'admin');
    
    return { admin, token };
  },

  logout: async () => {
    try {
      await api.post('/admin/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userType');
    }
  },

  me: async () => {
    const response = await api.get('/admin/me');
    return response.data;
  },

  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    return !!token && userType === 'admin';
  },

  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
};